module.exports = __webpack_public_path__ + "media/src/assets/Images/Size-eb472b7fd510f7bb5dc2c747db2fab4b.svg";